import { firebaseCache } from './firebaseCache';

/**
 * Global cache refresh utility
 * Invalidates all caches across the application to force fresh data fetch
 * Used by pull-to-refresh functionality on mobile screens
 */

/**
 * Invalidate all caches and force a complete refresh
 * This ensures that any changes made on desktop are reflected on mobile
 */
export const invalidateAllCaches = () => {
  console.log('🔄 Pull-to-refresh: Invalidating all caches');
  
  // Mark all caches for invalidation (will be cleared on next read)
  firebaseCache.markForInvalidation('policies');
  firebaseCache.markForInvalidation('clients');
  firebaseCache.markForInvalidation('meetings');
  
  console.log('✅ All caches invalidated - next fetch will be fresh from server');
};

/**
 * Force refresh all data by clearing cache completely
 * More aggressive than invalidation - immediately removes cached data
 */
export const forceRefreshAllData = () => {
  console.log('🔄 Force refresh: Clearing all caches immediately');
  
  // Clear all cache entries
  firebaseCache.clear();
  
  console.log('✅ All caches cleared - data will be fetched fresh');
};
